import { apiClient } from "helpers/api_helper";

export const getAllSalesInventoryData = async (data?: any) => {
    try {
        const response = await apiClient.get(`/api/v1/SalesInventory/GetSalesInventory`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};